var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"l-reality-upgrade-btn c-reality-upgrade-btn c-reality-upgrade-btn--black-hole-unlock",class:_vm.classObject,on:{"click":_vm.unlock}},[_vm._v(" Unleash the Black Hole "),_c('br'),_vm._v(" Cost: "+_vm._s(_vm.formatInt(100))+" Reality Machines ")])
}
var staticRenderFns = []

export { render, staticRenderFns }